
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import BaseApiState, { createBaseAPi } from "@/api/BaseApiState"
import { registerNewVenue, toggleVendorDiscount,getPendingVenueDetails,getVendorPromotions, getCompletedVenueDetails, getVendorVenueDetailsById, venueUpdateById,deleteSportById, getStaticConfig, updateVendorSportAndCourtOnEdit, addNewCourtInVendorSports, updateturfImages, deleteImages, getSlotsByDate,updateVendorVenueSlots ,toggleBookingByVenueId,createwebsite,getWebsiteByVendor,getVendorsBookingsWithPagination,getVendorsBookingsDetailsWithID,

  createVendorDiscount,getVendorDiscounts,checkAgreementStatus
} from '../thunkMidddleware/turfMiddleware';
import Strings from '@/constants/String';



interface Court {
  maxAllowedPlayers?:number,
  id?: string;
  _id?: string;
  courtName: string;
  courtNumber?: number;
  description: string;
  images?: string[];
  arenaSize: {
    length: number;
    width: number;
    unit: 'meters' | 'feet';
  };
  isActive: boolean;
  slotDurationInMinutes: 30 | 60 | 120;
  pricingRules: {
    weekday: { dayRate: number; nightRate: number };
    weekend: { dayRate: number; nightRate: number };
    holidays: { dayRate: number; nightRate: number };
  };
  availableSlots?: string[];
  courtType: string,
  sharedGround: boolean,
}
interface newCourtDataArg {
  venueId: string,
  sportId: string,
  courtData: Court

}
const newCourtData: newCourtDataArg = {
  venueId: "",
  sportId: "",
  courtData: {
    courtType:null,
    sharedGround:false,
    maxAllowedPlayers:null,
    courtName: "",
    courtNumber: null,
    description: "",
    images: [],
    arenaSize: {
      length: 0,
      width: 0,
      unit: "feet",
    },
    isActive: true,
    slotDurationInMinutes: 60,
    pricingRules: {
      weekday: { dayRate: 0, nightRate: 0 },
      weekend: { dayRate: 0, nightRate: 0 },
      holidays: { dayRate: 0, nightRate: 0 }
    },
    // availableSlots: []
  }
}


interface Sport {
  id?: string;
  _id?: string;
  name?: string;
  sportType?: string;
  description?: string;
  courts?: Court[];
}

interface TurfAddress {
  address: string;
  locality: string;
  city: string;
  state: string;
  pincode: string;
  googleLocationURL: string;
  isgoogleLink?:boolean;
}

// A venue that has only cleared the basic-info step comes back from the API
// with no address at all, so every place that hydrates `address` from a
// response falls back to this rather than leaving the form bound to undefined.
const EMPTY_ADDRESS: TurfAddress = {
  address: '',
  locality: '',
  city: '',
  state: '',
  pincode: '',
  googleLocationURL: '',
};

interface TurfState {

  createVendorDiscountResponse:createBaseAPi,
  getVendorDiscountsResponse:createBaseAPi,
  checkAgreementStatusResponse:createBaseAPi,
  isBasicInfoCompleted: boolean;
  basicInfo: {
    name: string;
    basePrice: any;
    description: string;
    amenities: string[];
  };

  address: TurfAddress;
  isAddressCompleted: boolean;

  sportsCategories: string[];
  sports: Sport[];
  loading: boolean;
  error: string | null;
  isDraft: boolean;

  currentOnboardVenueDetails?: createBaseAPi;
  pendingVenueDetails?: createBaseAPi;
  completedVenueDetails: createBaseAPi;
  VendorVenueDetailsById: createBaseAPi;
  venueUpdateByIdResponse: createBaseAPi;
  deleteSportByIdResponse: createBaseAPi;
  staticConfigResponse: createBaseAPi;
  BanksList:[];
  editSportAndCourtDetails: Sport;
  updateVendorSportAndCourtOnEditResponse: createBaseAPi;
  addNewCourtInVendorSportsResponse: createBaseAPi;
  addNewCourtState: newCourtDataArg,
  updateturfImagesResponse: createBaseAPi,
  deleteImagesResponse: createBaseAPi,
  getSlotsByDateResponse: createBaseAPi,
  updateVendorVenueSlotsResponse:createBaseAPi,
  toggleBookingByVenueIdResponse:createBaseAPi,
  toggleVendorDiscountResponse:createBaseAPi,
  createwebsiteResponse:createBaseAPi,
  getWebsiteByVendorResponse:createBaseAPi,
  getVendorPromotionsResponse:createBaseAPi,
  getVendorsBookingsWithPaginationResponse:createBaseAPi,
  getVendorsBookingsDetailsWithIDResponse:createBaseAPi


}

const initialState: TurfState = {
  checkAgreementStatusResponse:BaseApiState,
  toggleVendorDiscountResponse:BaseApiState,
  createVendorDiscountResponse:BaseApiState,
  getVendorDiscountsResponse:BaseApiState,
  basicInfo: {
    name: '',
    basePrice: '',
    description: '',
    amenities: [],
  },
  address: EMPTY_ADDRESS,
  sportsCategories: [],
  sports: [],
  loading: false,
  error: null,
  isDraft: false,
  isAddressCompleted: false,
  isBasicInfoCompleted: false,
  getVendorPromotionsResponse:BaseApiState,
  currentOnboardVenueDetails: BaseApiState,
  pendingVenueDetails: BaseApiState,
  completedVenueDetails: BaseApiState,
  VendorVenueDetailsById: BaseApiState,
  venueUpdateByIdResponse: BaseApiState,
  deleteSportByIdResponse: BaseApiState,

  staticConfigResponse: BaseApiState,
  editSportAndCourtDetails: {
    id: "",
    _id: "",
    name: "",
    sportType: "",
    description: "",
    courts: [{
      courtType:null,
      sharedGround:false,
      id: "",
      _id: "",
      courtName: "",
      courtNumber: null,
      description: "",
      images: [],
      arenaSize: {
        length: null,
        width: null,
        unit: 'meters' || 'feet',
      },
      isActive: false,
      slotDurationInMinutes: 30 || 60 || 120,
      pricingRules: {
        weekday: { dayRate: null, nightRate: null },
        weekend: { dayRate: null, nightRate: null },
        holidays: { dayRate: null, nightRate: null }
      },
      // availableSlots?: string[];
    }]
  },
  updateVendorSportAndCourtOnEditResponse: BaseApiState,
  addNewCourtInVendorSportsResponse: BaseApiState,
  addNewCourtState: newCourtData,
  updateturfImagesResponse: BaseApiState,
  deleteImagesResponse: BaseApiState,
  getSlotsByDateResponse: BaseApiState,
  updateVendorVenueSlotsResponse:BaseApiState,
  toggleBookingByVenueIdResponse:BaseApiState,
  createwebsiteResponse:BaseApiState,
  getWebsiteByVendorResponse:BaseApiState,
  BanksList:[],
  getVendorsBookingsWithPaginationResponse:BaseApiState,
  getVendorsBookingsDetailsWithIDResponse:BaseApiState
};

const turfSlice = createSlice({
  name: 'turf',
  initialState,
  reducers: {


    setAddNewCourtState: (state, action: PayloadAction<{ sportId: string, venueId: string, field: string, value: string | {} | boolean | number }>) => {
      let { field, venueId, sportId, value } = action.payload
      state.addNewCourtState = {
        sportId: sportId,
        venueId: venueId,
        courtData: {
          ...state.addNewCourtState.courtData,
          [field]: value
        }
      }
    },
    resetLocalSports:(state) => {
      state.sports = []

    },

    resetAddNewCourtState: (state) => {
      state.addNewCourtState = newCourtData
    },
    setEditSportAndCourtDetails: (state, action: PayloadAction<{ courtId?: string; sportsData: Sport }>) => {
      state.editSportAndCourtDetails = action.payload.sportsData
    },

    updateEditSportAndCourtDetails2: (state, action: PayloadAction<{ courtId?: string; sportsData: Sport }>) => {
      if (action.payload.courtId) {
        let courtIndex = state.editSportAndCourtDetails.courts.findIndex(ele => ele._id === action.payload.courtId)
        if (courtIndex !== -1) {
          state.editSportAndCourtDetails.courts[courtIndex] = {
            ...state.editSportAndCourtDetails.courts[courtIndex],
            ...action.payload.sportsData,
          };
        }
      } else {
        state.editSportAndCourtDetails = action.payload.sportsData

      }
    },

    updateEditCourtDetails: (state, action: PayloadAction<{ courtId: string; field: string, value: string | {} | boolean | number }>) => {
      const { courtId, field, value } = action.payload;

      // Find the index of the court
      const courtIndex = state.editSportAndCourtDetails.courts.findIndex(
        (court) => court.id === courtId || court._id === courtId
      );

      if (courtIndex !== -1) {
        // Update the court field dynamically
        state.editSportAndCourtDetails.courts[courtIndex] = {
          ...state.editSportAndCourtDetails.courts[courtIndex],
          [field]: value,
        };
      }
    },
    updateEditSportDetails: (state, action: PayloadAction<{ courtId?: string; sportsData: Sport }>) => {
      // const { field, value } = action.payload;
      // state.editSportAndCourtDetails[field] = value;
      state.editSportAndCourtDetails = action.payload.sportsData
    },
    setCurrentOnboardVenueDetails: (state, action) => {
      const { payload } = action
      state.currentOnboardVenueDetails.success = true
      state.currentOnboardVenueDetails.payload = payload
      state.basicInfo = {
        name: payload?.name,
        basePrice: payload?.baseBookingPricePerHour,
        description: payload?.description,
        amenities: payload?.amenities,
      }
    },
    resetVenueDeatils: (state, action) => {
      state.currentOnboardVenueDetails = BaseApiState;
      state.VendorVenueDetailsById = BaseApiState;
      state.sportsCategories = [],
        state.sports = [],
        state.basicInfo = {
          name: '',
          basePrice: '',
          description: '',
          amenities: [],
        };
      state.address = EMPTY_ADDRESS;

    },
    updateBasicInfo: (state, action: PayloadAction<Partial<typeof initialState.basicInfo>>) => {
      state.basicInfo = { ...state.basicInfo, ...action.payload };
    },
    updateAddress: (state, action: PayloadAction<Partial<TurfAddress>>) => {
      state.address = { ...state.address, ...action.payload };
    },
    setSportsCategories: (state, action: PayloadAction<string[]>) => {
      state.sportsCategories = action.payload;
    },

    addSport: (state, action: PayloadAction<Omit<Sport, 'id' | '_id' | 'courts'>>) => {
      const newSport: Sport = {
        ...action.payload,
        id: Date.now().toString(),
        _id: Date.now().toString(),
        courts: [],
      };
      // state.sports.push(newSport);
      state.sports = [...state.sports, newSport];

    },
    updateSport: (state, action: PayloadAction<{ id: string; updates: Partial<Sport> }>) => {
      const index = state.sports.findIndex(sport => sport._id === action.payload.id);
      if (index !== -1) {
        state.sports[index] = { ...state.sports[index], ...action.payload.updates };
      }
    },
    deleteSport: (state, action: PayloadAction<{ id: string }>) => {
      const newdata = state.sports.filter(sport => sport._id !== action.payload.id);
      state.sports = newdata
    },
    addCourt: (state, action: PayloadAction<{ sportId: string; court: Omit<Court, 'id'> }>) => {
      const sportIndex = state.sports.findIndex(sport => sport._id === action.payload.sportId);
      if (sportIndex !== -1) {
        const newCourt: Court = {
          ...action.payload.court,
          courtNumber: state.sports[sportIndex].courts.length + 1,
          id: Date.now().toString(),
          _id: Date.now().toString(),

        };
        state.sports[sportIndex].courts.push(newCourt);
      }
    },
    updateCourt: (state, action: PayloadAction<{ sportId: string; courtId: string; updates: Partial<Court> }>) => {
      const sportIndex = state.sports.findIndex(sport => sport._id === action.payload.sportId);
      if (sportIndex !== -1) {
        const courtIndex = state.sports[sportIndex].courts.findIndex(court => court._id === action.payload.courtId);
        if (courtIndex !== -1) {
          state.sports[sportIndex].courts[courtIndex] = {
            ...state.sports[sportIndex].courts[courtIndex],
            ...action.payload.updates,
          };
        }
      }
    },

    deleteCourt: (state, action: PayloadAction<{ sportId: string, courtId: string }>) => {
      const sportIndex = state.sports.findIndex(sport => sport._id === action.payload.sportId);
      const newdata = state.sports[sportIndex].courts.filter(ele => ele._id !== action.payload.courtId);
      state.sports[sportIndex].courts = newdata;
    },
    setIsDraft: (state, action: PayloadAction<boolean>) => {
      state.isDraft = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerNewVenue.pending, (state) => {
        state.currentOnboardVenueDetails.isLoading = true;
        state.currentOnboardVenueDetails.error = null;
        state.currentOnboardVenueDetails.success = false;
        state.currentOnboardVenueDetails.message = null;

      })
      .addCase(registerNewVenue.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.currentOnboardVenueDetails.isLoading = false;
        state.currentOnboardVenueDetails.payload = payload;
        state.currentOnboardVenueDetails.message = message;

        // state.addressDetails = payload?.address;
        // state.bankDetails = payload?.bankDetails;
        // state.isAddressCompleted = payload?.isAddressCompleted;
        // state.isBankDetailsCompleted = payload?.isBankDetailsCompleted;

        state.basicInfo = {
          name: payload?.name,
          basePrice: payload?.baseBookingPricePerHour,
          description: payload?.description,
          amenities: payload?.amenities,
        }

      })
      .addCase(registerNewVenue.rejected, (state, action) => {
        state.currentOnboardVenueDetails.isLoading = false;
        // state.error = action?.error as string;
        state.currentOnboardVenueDetails.success = false

      });

    // --------------------------------------------------------------------------------
    builder
      .addCase(getPendingVenueDetails.pending, (state) => {
        state.pendingVenueDetails.isLoading = true;
        state.pendingVenueDetails.error = null;
        state.pendingVenueDetails.success = false;
        state.pendingVenueDetails.message = null;

      })
      .addCase(getPendingVenueDetails.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.pendingVenueDetails.isLoading = false;
        state.pendingVenueDetails.payload = payload;
        state.pendingVenueDetails.message = message;

      })
      .addCase(getPendingVenueDetails.rejected, (state, action) => {
        state.pendingVenueDetails.isLoading = false;
        // state.error = action?.error as string;
        state.pendingVenueDetails.success = false

      });
    // --------------------------------------------------------------------------------
    builder
      .addCase(getCompletedVenueDetails.pending, (state) => {
        state.completedVenueDetails.isLoading = true;
        state.completedVenueDetails.error = null;
        state.completedVenueDetails.success = false;
        state.completedVenueDetails.message = null;

      })
      .addCase(getCompletedVenueDetails.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.completedVenueDetails.isLoading = false;
        state.completedVenueDetails.payload = payload;
        state.completedVenueDetails.message = message;

      })
      .addCase(getCompletedVenueDetails.rejected, (state, action) => {
        state.completedVenueDetails.isLoading = false;
        // state.error = action?.error as string;
        state.completedVenueDetails.success = false

      });


    // --------------------------------------------------------------------------------
    builder
      .addCase(getVendorVenueDetailsById.pending, (state) => {
        state.VendorVenueDetailsById.isLoading = true;
        state.VendorVenueDetailsById.error = null;
        state.VendorVenueDetailsById.success = false;
        state.VendorVenueDetailsById.message = null;

      })
      .addCase(getVendorVenueDetailsById.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.VendorVenueDetailsById.isLoading = false;
        state.VendorVenueDetailsById.payload = payload;
        state.VendorVenueDetailsById.message = message;
        state.currentOnboardVenueDetails.payload = payload;

        state.basicInfo = {
          name: payload?.name,
          basePrice: payload?.baseBookingPricePerHour,
          description: payload?.description,
          amenities: payload?.amenities,
        }
        state.address = payload?.address || EMPTY_ADDRESS;
        state.sportsCategories = payload?.sportsCategories || []
        // state.sports = payload?.sports || []
      })
      .addCase(getVendorVenueDetailsById.rejected, (state, action) => {
        state.VendorVenueDetailsById.isLoading = false;
        state.VendorVenueDetailsById.error = action.payload
        // state.error = action?.error as string;
        state.VendorVenueDetailsById.success = false

      });


    // --------------------------------------------------------------------------------

    // --------------------------------------------------------------------------------
    builder
      .addCase(venueUpdateById.pending, (state) => {
        state.venueUpdateByIdResponse.isLoading = true;
        state.venueUpdateByIdResponse.error = null;
        state.venueUpdateByIdResponse.success = false;
        state.venueUpdateByIdResponse.message = null;

      })
      .addCase(venueUpdateById.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.venueUpdateByIdResponse.isLoading = false;
        state.venueUpdateByIdResponse.payload = payload;
        state.venueUpdateByIdResponse.message = message;
        state.venueUpdateByIdResponse.payload = payload;

      
      })
      .addCase(venueUpdateById.rejected, (state, action) => {
        state.venueUpdateByIdResponse.isLoading = false;
        // state.error = action?.error as string;
        state.venueUpdateByIdResponse.success = false

      });

   // --------------------------------------------------------------------------------
   builder
   .addCase(deleteSportById.pending, (state) => {
     state.deleteSportByIdResponse.isLoading = true;
     state.deleteSportByIdResponse.error = null;
     state.deleteSportByIdResponse.success = false;
     state.deleteSportByIdResponse.message = null;

   })
   .addCase(deleteSportById.fulfilled, (state, action) => {
     let { payload, message } = action.payload
     state.deleteSportByIdResponse.isLoading = false;
     state.deleteSportByIdResponse.payload = payload;
     state.deleteSportByIdResponse.message = message;
     state.deleteSportByIdResponse.payload = payload;

     state.VendorVenueDetailsById.payload = payload;

   })
   .addCase(deleteSportById.rejected, (state, action) => {
     state.deleteSportByIdResponse.isLoading = false;
     // state.error = action?.error as string;
     state.deleteSportByIdResponse.success = false

   });

    // --------------------------------------------------------------------------------
    builder
      .addCase(getStaticConfig.pending, (state) => {
        state.staticConfigResponse.isLoading = true;
        state.staticConfigResponse.error = null;
        state.staticConfigResponse.success = false;
        state.staticConfigResponse.message = null;

      })
      .addCase(getStaticConfig.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.staticConfigResponse.isLoading = false;
        state.staticConfigResponse.payload = payload;
        state.staticConfigResponse.message = message;
        state.staticConfigResponse.payload = payload;
        if(payload?.key === Strings.staticConfigKeys.banks && payload?.values){
          state.BanksList = payload?.values
        }
       
      })
      .addCase(getStaticConfig.rejected, (state, action) => {
        state.staticConfigResponse.isLoading = false;
        // state.error = action?.error as string;
        state.staticConfigResponse.success = false

      });


    // --------------------------------------------------------------------------------

    // --------------------------------------------------------------------------------
    builder
      .addCase(updateVendorSportAndCourtOnEdit.pending, (state) => {
        state.updateVendorSportAndCourtOnEditResponse.isLoading = true;
        state.updateVendorSportAndCourtOnEditResponse.error = null;
        state.updateVendorSportAndCourtOnEditResponse.success = false;
        state.updateVendorSportAndCourtOnEditResponse.message = null;

      })
      .addCase(updateVendorSportAndCourtOnEdit.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.updateVendorSportAndCourtOnEditResponse.isLoading = false;
        state.updateVendorSportAndCourtOnEditResponse.payload = payload;
        state.updateVendorSportAndCourtOnEditResponse.message = message;
        state.updateVendorSportAndCourtOnEditResponse.payload = payload;

      })
      .addCase(updateVendorSportAndCourtOnEdit.rejected, (state, action) => {
        state.updateVendorSportAndCourtOnEditResponse.isLoading = false;
        // state.error = action?.error as string;
        state.updateVendorSportAndCourtOnEditResponse.success = false

      });


    // --------------------------------------------------------------------------------

    // --------------------------------------------------------------------------------
    builder
      .addCase(addNewCourtInVendorSports.pending, (state) => {
        state.addNewCourtInVendorSportsResponse.isLoading = true;
        state.addNewCourtInVendorSportsResponse.error = null;
        state.addNewCourtInVendorSportsResponse.success = false;
        state.addNewCourtInVendorSportsResponse.message = null;

      })
      .addCase(addNewCourtInVendorSports.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.addNewCourtInVendorSportsResponse.isLoading = false;
        state.addNewCourtInVendorSportsResponse.payload = payload;
        state.addNewCourtInVendorSportsResponse.message = message;
        state.addNewCourtInVendorSportsResponse.payload = payload;

      })
      .addCase(addNewCourtInVendorSports.rejected, (state, action) => {
        state.addNewCourtInVendorSportsResponse.isLoading = false;
        // state.error = action?.error as string;
        state.addNewCourtInVendorSportsResponse.success = false

      });


    // --------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------
    builder
      .addCase(updateturfImages.pending, (state) => {
        state.updateturfImagesResponse.isLoading = true;
        state.updateturfImagesResponse.error = null;
        state.updateturfImagesResponse.success = false;
        state.updateturfImagesResponse.message = null;

      })
      .addCase(updateturfImages.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.updateturfImagesResponse.isLoading = false;
        state.updateturfImagesResponse.payload = payload;
        state.updateturfImagesResponse.message = message;
        state.updateturfImagesResponse.payload = payload;

      })
      .addCase(updateturfImages.rejected, (state, action) => {
        state.updateturfImagesResponse.isLoading = false;
        // state.error = action?.error as string;
        state.updateturfImagesResponse.success = false

      });


    // --------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------
    builder
      .addCase(deleteImages.pending, (state) => {
        state.deleteImagesResponse.isLoading = true;
        state.deleteImagesResponse.error = null;
        state.deleteImagesResponse.success = false;
        state.deleteImagesResponse.message = null;

      })
      .addCase(deleteImages.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.deleteImagesResponse.isLoading = false;
        state.deleteImagesResponse.payload = payload;
        state.deleteImagesResponse.message = message;
        state.deleteImagesResponse.payload = payload;

      })
      .addCase(deleteImages.rejected, (state, action) => {
        state.deleteImagesResponse.isLoading = false;
        // state.error = action?.error as string;
        state.deleteImagesResponse.success = false

      });


    // --------------------------------------------------------------------------------

    // --------------------------------------------------------------------------------
    builder
      .addCase(getSlotsByDate.pending, (state) => {
        state.getSlotsByDateResponse.isLoading = true;
        state.getSlotsByDateResponse.error = null;
        state.getSlotsByDateResponse.success = false;
        state.getSlotsByDateResponse.message = null;

      })
      .addCase(getSlotsByDate.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.getSlotsByDateResponse.isLoading = false;
        state.getSlotsByDateResponse.payload = payload;
        state.getSlotsByDateResponse.message = message;

      })
      .addCase(getSlotsByDate.rejected, (state, action) => {
        state.getSlotsByDateResponse.isLoading = false;
        // state.error = action?.error as string;
        state.getSlotsByDateResponse.success = false

      });


    // --------------------------------------------------------------------------------

       // --------------------------------------------------------------------------------
       builder
       .addCase(updateVendorVenueSlots.pending, (state) => {
         state.updateVendorVenueSlotsResponse.isLoading = true;
         state.updateVendorVenueSlotsResponse.error = null;
         state.updateVendorVenueSlotsResponse.success = false;
         state.updateVendorVenueSlotsResponse.message = null;
 
       })
       .addCase(updateVendorVenueSlots.fulfilled, (state, action) => {
         let { payload, message } = action.payload
         state.updateVendorVenueSlotsResponse.isLoading = false;
         state.updateVendorVenueSlotsResponse.payload = payload;
         state.getSlotsByDateResponse.payload=payload
         state.updateVendorVenueSlotsResponse.message = message;
 
       })
       .addCase(updateVendorVenueSlots.rejected, (state, action) => {
         state.updateVendorVenueSlotsResponse.isLoading = false;
         // state.error = action?.error as string;
         state.updateVendorVenueSlotsResponse.success = false
 
       });
 
 
     // --------------------------------------------------------------------------------
 
       // --------------------------------------------------------------------------------
       builder
       .addCase(toggleBookingByVenueId.pending, (state) => {
         state.toggleBookingByVenueIdResponse.isLoading = true;
         state.toggleBookingByVenueIdResponse.error = null;
         state.toggleBookingByVenueIdResponse.success = false;
         state.toggleBookingByVenueIdResponse.message = null;
 
       })
       .addCase(toggleBookingByVenueId.fulfilled, (state, action) => {
         let { payload, message ,success} = action.payload
         state.toggleBookingByVenueIdResponse.isLoading = false;
         state.toggleBookingByVenueIdResponse.payload = payload;
         state.toggleBookingByVenueIdResponse.message = message;
         state.toggleBookingByVenueIdResponse.success = success;

 
       })
       .addCase(toggleBookingByVenueId.rejected, (state, action) => {
         state.toggleBookingByVenueIdResponse.isLoading = false;
         // state.error = action?.error as string;
         state.toggleBookingByVenueIdResponse.success = false
 
       });
 
 
     // --------------------------------------------------------------------------------
 
           // --------------------------------------------------------------------------------
           builder
           .addCase(createwebsite.pending, (state) => {
             state.createwebsiteResponse.isLoading = true;
             state.createwebsiteResponse.error = null;
             state.createwebsiteResponse.success = false;
             state.createwebsiteResponse.message = null;
     
           })
           .addCase(createwebsite.fulfilled, (state, action) => {
             let { payload, message ,success} = action.payload
             state.createwebsiteResponse.isLoading = false;
             state.createwebsiteResponse.payload = payload;
             state.createwebsiteResponse.message = message;
             state.createwebsiteResponse.success = success;
    
     
           })
           .addCase(createwebsite.rejected, (state, action) => {
             state.createwebsiteResponse.isLoading = false;
             // state.error = action?.error as string;
             state.createwebsiteResponse.success = false
     
           });
     
     
         // --------------------------------------------------------------------------------
     
    

           // --------------------------------------------------------------------------------
           builder
           .addCase(getWebsiteByVendor.pending, (state) => {
             state.getWebsiteByVendorResponse.isLoading = true;
             state.getWebsiteByVendorResponse.error = null;
             state.getWebsiteByVendorResponse.success = false;
             state.getWebsiteByVendorResponse.message = null;
     
           })
           .addCase(getWebsiteByVendor.fulfilled, (state, action) => {
             let { payload, message ,success} = action.payload
             state.getWebsiteByVendorResponse.isLoading = false;
             state.getWebsiteByVendorResponse.payload = payload;
             state.createwebsiteResponse.payload=payload;
             state.getWebsiteByVendorResponse.message = message;
             state.getWebsiteByVendorResponse.success = success;
    
     
           })
           .addCase(getWebsiteByVendor.rejected, (state, action) => {
             state.getWebsiteByVendorResponse.isLoading = false;
             // state.error = action?.error as string;
             state.getWebsiteByVendorResponse.success = false
     
           });
     
     
         // --------------------------------------------------------------------------------

          // --------------------------------------------------------------------------------
          builder
          .addCase(getVendorPromotions.pending, (state) => {
            state.getVendorPromotionsResponse.isLoading = true;
            state.getVendorPromotionsResponse.error = null;
            state.getVendorPromotionsResponse.success = false;
            state.getVendorPromotionsResponse.message = null;
    
          })
          .addCase(getVendorPromotions.fulfilled, (state, action) => {
            let { payload, message ,success} = action.payload
            state.getVendorPromotionsResponse.isLoading = false;
            state.getVendorPromotionsResponse.payload = payload;
            state.getVendorPromotionsResponse.message = message;
            state.getVendorPromotionsResponse.success = success;
   
    
          })
          .addCase(getVendorPromotions.rejected, (state, action) => {
            state.getVendorPromotionsResponse.isLoading = false;
            // state.error = action?.error as string;
            state.getVendorPromotionsResponse.success = false
    
          });
    
    //-----------------------------------------------------------------------------------
    builder
    .addCase(getVendorsBookingsWithPagination.pending, (state,action:any) => {
     
        state.getVendorsBookingsWithPaginationResponse.isLoading = true; 
        state.getVendorsBookingsWithPaginationResponse.error = null;
    })
       .addCase(getVendorsBookingsWithPagination.fulfilled, (state, action: any) => {
        state.getVendorsBookingsWithPaginationResponse.isLoading = false;
        state.getVendorsBookingsWithPaginationResponse.success = action.payload?.success;
        state.getVendorsBookingsWithPaginationResponse.error = null;
    
        const newPayload = action.payload?.payload;
        state.getVendorsBookingsWithPaginationResponse.payload = newPayload;
    })
    .addCase(getVendorsBookingsWithPagination.rejected, (state, action) => {
        state.getVendorsBookingsWithPaginationResponse.isLoading = false;
        state.getVendorsBookingsWithPaginationResponse.error = action?.payload || action?.error as any;
        state.getVendorsBookingsWithPaginationResponse.success = false
        state.getVendorsBookingsWithPaginationResponse.payload = null
    });


      //-----------------------------------------------------------------------------------
      builder
      .addCase(getVendorsBookingsDetailsWithID.pending, (state,action:any) => {
       
          state.getVendorsBookingsDetailsWithIDResponse.isLoading = true; 
          state.getVendorsBookingsDetailsWithIDResponse.error = null;
      })
         .addCase(getVendorsBookingsDetailsWithID.fulfilled, (state, action: any) => {
          state.getVendorsBookingsDetailsWithIDResponse.isLoading = false;
          state.getVendorsBookingsDetailsWithIDResponse.success = action.payload?.success;
          state.getVendorsBookingsDetailsWithIDResponse.error = null;
      
          const newPayload = action.payload?.payload;
          state.getVendorsBookingsDetailsWithIDResponse.payload = newPayload;
      })
      .addCase(getVendorsBookingsDetailsWithID.rejected, (state, action) => {
          state.getVendorsBookingsDetailsWithIDResponse.isLoading = false;
          state.getVendorsBookingsDetailsWithIDResponse.error = action?.payload || action?.error as any;
          state.getVendorsBookingsDetailsWithIDResponse.success = false
          state.getVendorsBookingsDetailsWithIDResponse.payload = null
      });
      

      //-----------------------------------------------------------------------------------
      builder
      .addCase(getVendorDiscounts.pending, (state,action:any) => {
       
          state.getVendorDiscountsResponse.isLoading = true; 
          state.getVendorDiscountsResponse.error = null;
      })
         .addCase(getVendorDiscounts.fulfilled, (state, action: any) => {
          state.getVendorDiscountsResponse.isLoading = false;
          state.getVendorDiscountsResponse.success = action.payload?.success;
          state.getVendorDiscountsResponse.error = null;
          const newPayload = action.payload?.payload;
          state.getVendorDiscountsResponse.payload = newPayload;
      })
      .addCase(getVendorDiscounts.rejected, (state, action) => {
          state.getVendorDiscountsResponse.isLoading = false;
          state.getVendorDiscountsResponse.error = action?.payload || action?.error as any;
          state.getVendorDiscountsResponse.success = false
          state.getVendorDiscountsResponse.payload = null
      });

         //-----------------------------------------------------------------------------------
      builder
      .addCase(createVendorDiscount.pending, (state,action:any) => {
       
          state.createVendorDiscountResponse.isLoading = true; 
          state.createVendorDiscountResponse.error = null;
      })
         .addCase(createVendorDiscount.fulfilled, (state, action: any) => {
          state.createVendorDiscountResponse.isLoading = false;
          state.createVendorDiscountResponse.success = action.payload?.success;
          state.createVendorDiscountResponse.error = null;
          const newPayload = action.payload?.payload;
          state.createVendorDiscountResponse.payload = newPayload;
      })
      .addCase(createVendorDiscount.rejected, (state, action) => {
          state.createVendorDiscountResponse.isLoading = false;
          state.createVendorDiscountResponse.error = action?.payload || action?.error as any;
          state.createVendorDiscountResponse.success = false
          state.createVendorDiscountResponse.payload = null
      });


         //-----------------------------------------------------------------------------------
      builder
      .addCase(checkAgreementStatus.pending, (state,action:any) => {
          state.checkAgreementStatusResponse.isLoading = true; 
          state.checkAgreementStatusResponse.error = null;
      })
         .addCase(checkAgreementStatus.fulfilled, (state, action: any) => {
          state.checkAgreementStatusResponse.isLoading = false;
          state.checkAgreementStatusResponse.success = action.payload?.success;
          state.checkAgreementStatusResponse.error = null;
          state.checkAgreementStatusResponse.payload = action.payload?.payload;;
      })
      .addCase(checkAgreementStatus.rejected, (state, action) => {
          state.checkAgreementStatusResponse.isLoading = false;
          state.checkAgreementStatusResponse.error = action?.payload || action?.error as any;
          state.checkAgreementStatusResponse.success = false
          state.checkAgreementStatusResponse.payload = null
      });

          //-----------------------------------------------------------------------------------
      builder
      .addCase(toggleVendorDiscount.pending, (state,action:any) => {
       
          state.toggleVendorDiscountResponse.isLoading = true; 
          state.toggleVendorDiscountResponse.error = null;
      })
         .addCase(toggleVendorDiscount.fulfilled, (state, action: any) => {
          state.toggleVendorDiscountResponse.isLoading = false;
          state.toggleVendorDiscountResponse.success = action.payload?.success;
          state.toggleVendorDiscountResponse.error = null;
          const newPayload = action.payload?.payload;
          state.toggleVendorDiscountResponse.payload = newPayload;
      })
      .addCase(toggleVendorDiscount.rejected, (state, action) => {
          state.toggleVendorDiscountResponse.isLoading = false;
          state.toggleVendorDiscountResponse.error = action?.payload || action?.error as any;
          state.toggleVendorDiscountResponse.success = false
          state.toggleVendorDiscountResponse.payload = null
      });
  },
});

export const {
  resetAddNewCourtState,
  setAddNewCourtState,
  setEditSportAndCourtDetails,
  updateEditCourtDetails,
  updateEditSportDetails,
  updateBasicInfo,
  updateAddress,
  setSportsCategories,
  addSport,
  updateSport,
  addCourt,
  updateCourt,
  setIsDraft,
  setLoading,
  setError,
  setCurrentOnboardVenueDetails,
  resetVenueDeatils,
  deleteSport,
  deleteCourt,
  resetLocalSports
} = turfSlice.actions;
export default turfSlice.reducer;
